"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductList = void 0;
const react_1 = __importStar(require("react"));
const classify_modal_styles_1 = require("./classify-modal.styles");
const use_fetch_products_hook_1 = require("./hooks/use-fetch-products.hook");
const localization_1 = require("../../../../localization");
const product_card_1 = require("../../../components/product-card");
const selectors_1 = require("../../../../store/selectors");
const LIMIT_PRODUCTS = 100;
const ProductList = ({ expanded, setExpanded, productsCount, className, activeFilter, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [countOffset, setCountOffset] = (0, react_1.useState)(0);
    const isExclusionModeOn = (0, selectors_1.useIsExclusionModeOn)();
    const { products, hasMore, loading, onCheckProduct, } = (0, use_fetch_products_hook_1.useFetchProducts)(countOffset, LIMIT_PRODUCTS, activeFilter);
    const observer = (0, react_1.useRef)(null);
    const lastProductElementRef = (0, react_1.useCallback)((node) => {
        if (loading)
            return;
        if (observer.current)
            observer.current.disconnect();
        if (isExclusionModeOn) {
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    if (hasMore) {
                        setCountOffset(countOffset + LIMIT_PRODUCTS);
                    }
                }
            });
            if (node)
                observer.current.observe(node);
        }
    }, [loading, hasMore]);
    return (react_1.default.createElement(classify_modal_styles_1.StyledAccordion, { className: className, expanded: expanded, onChange: (_, isExpanded) => setExpanded(isExpanded) }, react_1.default.createElement(classify_modal_styles_1.StylesAccordionSummary, { expandIcon: react_1.default.createElement(classify_modal_styles_1.StyledArrowForwardIosSharp, null) }, react_1.default.createElement("div", null, t({ key: 'CLASSIFY_MODAL_PRODUCTS', values: { productsCount } }))), react_1.default.createElement(classify_modal_styles_1.StyleAccordionDetails, null, products.map((el) => (react_1.default.createElement("div", { ref: lastProductElementRef, key: el.id }, react_1.default.createElement(product_card_1.ProductCard, Object.assign(Object.assign({}, el), { onCheckProduct: onCheckProduct }))))), loading && react_1.default.createElement(classify_modal_styles_1.StyledLoading, { iconOrientation: "right", isLoading: true, progressSize: 25, showEllipsis: false }))));
};
exports.ProductList = ProductList;
exports.default = exports.ProductList;
